var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"greedy flex column flex-align-center justify-center",attrs:{"id":"done-empty"}},[_c('p',{staticClass:"chat-bubble"},[_vm._v("💬")])])
}]

export { render, staticRenderFns }